import { createMyApp } from "~/lib/myVue";
import App from "~/App";
import regComponents from "~/lib/registerScripts/regComponents";
import regGspDesignSystem from "~/lib/registerScripts/regGspDesignSystem";
import regPlugins from "~/lib/registerScripts/regPlugins";
import store from "~/lib/centralStore/index";
import autoGeneratedRoutes from "vue-auto-routing";
import { createRouter, createWebHistory } from "vue-router";
import setAccessToken from "~/lib/accessToken";
import initAxiosInterceptors from "~/lib/axiosInterceptors";
import setupYup from "~/lib/yup/setup";

const routes = autoGeneratedRoutes.map((route) => ({
  ...route,
  path: route.path.indexOf("/") == 0 ? route.path : "/" + route.path,
}));

setAccessToken();

regGspDesignSystem();

initAxiosInterceptors();

setupYup();

export default function (context) {
  const myApp = createMyApp(App);

  regComponents(myApp, context);

  const router = createRouter({
    history: createWebHistory(context.routeBase || undefined),
    routes: routes,
  });

  myApp.use(router);
  myApp.router = router;

  myApp.use(store);
  myApp.store = store;

  regPlugins(myApp, context);

  return {
    mount: myApp.mount,
    unmount: myApp.unmount,
  };
}
